import { aliases, mdi } from 'vuetify/iconsets/mdi-svg'
// import 'vuetify/styles'
// import '@/styles/app.scss'
import '@/styles/main.scss'

import { Intersect } from 'vuetify/directives'
import { createVuetify } from 'vuetify'
import dark from '@/themes/dark'
import light from '@/themes/light'
import dm from '@/themes/dm'
import bipa from '@/themes/bipa'

export default createVuetify({
  directives: {
    Intersect
  },
  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: {
      mdi
    }
  },
  theme: {
    themes: {
      dark,
      light,
      dm,
      bipa
    }
  }
})
